import t from "module/translations";
import { CertificationState } from "module/certification/types";

export const getCertificationStateTranslation = (
  state: CertificationState
): string =>
  ({
    [CertificationState.initScheduled]:
      t.competencyManagement.certification.state.scheduledText,
    [CertificationState.scheduled]:
      t.competencyManagement.certification.state.scheduledText,
    [CertificationState.completed]:
      t.competencyManagement.certification.state.completedText,
  }[state]);
